const error410 = {
  name: 'Erro 410',
  title: 'Página não disponível',
  subtitle: 'Que pena! Esse link não está mais disponível.',
};

export default error410;
